module.exports = __webpack_public_path__ + "media/images/front/common/no_image_doctor-f9a5663281672013070e7c33e71dabc9.png";